import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { LayerMeta, updateLayerMeta } from "../../../ducks/project/project";

import { LayerInfo } from "../../../interfaces/resourceInfo";

export const useLayerItemFetchEffect = (
  options: LayerMeta & {
    layerName: string;
    layer: LayerInfo;
  },
) => {
  const dispatch = useDispatch();
  const { layerName, layer, status, lastCount, count, isVisible, geometryAttribute } = options;

  useEffect(() => {
    if (layer.name || status) {
      dispatch(
        updateLayerMeta({
          name: layer.name || layerName,
          alias: layer.alias,
          status,
          lastCount,
          count,
          isVisible,
          geometryAttribute,
          type: layer.type,
        }),
      );
    }
  }, [layer.name, status, lastCount, count, layer.alias, layerName, isVisible, geometryAttribute]);
};
